import { SET_ANALYTICS_TRIGGER } from '../actions';

export default function analitycsTrigger(state = '', action: any) {
  switch (action.type) {
    case SET_ANALYTICS_TRIGGER:
      return action.payload;
    default:
      return state;
  }
}
